import type { TSectionElement } from '@shared/dream-components';

import type { ProprietaryFooterNode } from '~/components/DreamBuilder/nodes/ProprietaryFooter';
import type { NodeContent } from '~/interfaces/page';
import type { Publication } from '~/interfaces/publication';

import { getColors } from './getColors';

export const findAndInsertProprietaryNode = (footerNode: NodeContent, webTheme: Publication['web_theme']) => {
  if (footerNode && 'type' in footerNode && footerNode.type !== 'doc') {
    return footerNode;
  }

  if (!footerNode?.content || footerNode.content.length === 0) {
    return footerNode;
  }

  const lastSection = (footerNode.content as NodeContent[])[footerNode.content.length - 1] as TSectionElement;

  const { textColor } = getColors(lastSection, webTheme);

  const newElement = {
    type: 'proprietaryFooter',
    attrs: {
      id: 'proprietaryFooterContainer',
      backgroundColor: lastSection.attrs.backgroundColor,
      color: textColor,
    },
  } as ProprietaryFooterNode;

  const footerContentWithoutLastSection = [...footerNode.content];
  footerContentWithoutLastSection.pop();

  return {
    ...footerNode,
    content: [
      ...footerContentWithoutLastSection,
      {
        ...lastSection,
        content: Array.isArray(lastSection.content) ? [...lastSection.content, newElement] : [],
      },
    ],
  } as NodeContent;
};
